// Datos dummy para los planes de capacitación
export const trainingPlans = [
    {
      id: 1,
      nameTrainingPlan: "Plan de Desarrollo de Liderazgo",
      areas: "AEROMEXICO/Staffing",
      status: "Terminado",
      calification: '90',
      fechaInicio: "2023-01-15",
      endTrainingPlan: "2023-12-15",
    },
    {
      id: 2,
      nameTrainingPlan: "Formación en Ventas",
      areas: "Business Development/Staff",
      status: "Terminado",
      calification: '78',
      fechaInicio: "2023-02-01",
      endTrainingPlan: "2023-08-01",
    },
    {
      id: 3,
      nameTrainingPlan: "Capacitación Técnica en IT",
      nameEnterprise: "IT-SEEKERS",
      areas: "Assurant/Staffing",
      status: "Terminado",
      calification: '87',
      fechaInicio: "2023-05-10",
      endTrainingPlan: "2023-11-10",
    },
    {
        id: 4,
        nameTrainingPlan: "Plan anual de capacitación",
        areas: "AEROMEXICO/Staffing, Assurant/Staffing",
        status: "Terminado",
        calification: '10',
        fechaInicio: "2023-05-10",
        endTrainingPlan: "2023-11-10",
    },
    {
        id: 5,
        nameTrainingPlan: "Plan de capacitación en diversidad e inclusión",
        areas: "Capital Humano/staff",
        status: "En progreso",
        calification: 'Pendiente',
        fechaInicio: "2023-05-10",
        endTrainingPlan: "2023-11-10",
    },
    {
        id: 6,
        nameTrainingPlan: "Plan de capacitación en desarrollo profesional",
        areas: "Bits/staff",
        status: "En progreso",
        calification: 'Pendiente',
        fechaInicio: "2023-05-10",
        endTrainingPlan: "2023-11-10",
    },
    {
        id: 7,
        nameTrainingPlan: "Certificación Integral en Quality Assurance",
        areas: "Bits/staff",
        status: "En progreso",
        calification: 'Pendiente',
        fechaInicio: "2023-05-10",
        endTrainingPlan: "2023-11-10",
    },
    {
        id: 8,
        nameTrainingPlan: "Plan de capacitación en desarrollo de creatividad",
        areas: "Bits/staff, Capital Humano/staff",
        status: "En progreso",
        calification: "Pendiente",
        fechaInicio: "2023-05-10",
        endTrainingPlan: "2023-11-10",
    },
    {
        id: 9,
        nameTrainingPlan: "Plan de capacitación para aprender de tecnología",
        areas: "Bits/staff",
        status: "Terminado",
        calification: '100',
        fechaInicio: "2023-05-10",
        endTrainingPlan: "2023-11-10",
    },
    {
        id: 10,
        nameTrainingPlan: "Capacitación y desarrollo de Recursos Humanos",
        areas: "Dirección/staff",
        status: "En progreso",
        calification: 'Pendiente',
        fechaInicio: "2023-05-10",
        endTrainingPlan: "2023-11-10",
    },
    {
        id: 11,
        nameTrainingPlan: "Plan de capacitación en habilidades técnicas",
        areas: "Bits/staff, Development/Staff",
        status: "Terminado",
        calification: '0',
        fechaInicio: "2023-05-10",
        endTrainingPlan: "2023-11-10",
    },
  ];
  
  // Datos dummy para los cursos
  export const courses = [
    {
      id: 1,
      title: "Curso de Python",
      areas: "Development/Staff",
      status: "Terminado",
      calification: 'Pendiente',
      fechaInicio: "2023-01-20",
      dateEnd: "2023-03-20",
    },
    {
      id: 2,
      title: "Curso de Excel Avanzado",
      areas: "Talent Attraction/Staff",
      status: "En progreso",
      calification: 'Pendiente',
      fechaInicio: "2023-04-15",
      dateEnd: "2023-06-15",
    },
    {
      id: 3,
      title: "Curso de Gestión de Proyectos",
      areas: "Administración",
      status: "En progreso",
      calification: 'Pendiente',
      fechaInicio: "2023-07-01",
      dateEnd: "2023-09-01",
    },
    {
        id: 4,
        title: "Métricas y Análisis en QA",
        areas: "QA/Staff",
        status: "En progreso",
        calification: 'Pendiente',
        fechaInicio: "2023-07-01",
        dateEnd: "2023-09-01",
    },
    {
        id: 5,
        title: "Innovación en Automatización de Pruebas",
        areas: "QA/Staff, Bits/Staff",
        status: "En progreso",
        calification: 'Pendiente',
        fechaInicio: "2023-07-01",
        dateEnd: "2023-09-01",
    },
    {
        id: 6,
        title: "Fundamentos de Aseguramiento de la Calidad de Soft",
        areas: "AEROMEXICO/Staffing, It Support/staff",
        status: "Terminado",
        calification: '85',
        fechaInicio: "2023-07-01",
        dateEnd: "2023-09-01",
    },
    {
        id: 7,
        title: "Seguridad y Pruebas de Software Resiliente",
        areas: "Seguridad informatica/Staff, Assurant/Staffing",
        status: "En progreso",
        calification: 'Pendiente',
        fechaInicio: "2023-07-01",
        dateEnd: "2023-09-01",
    },
    {
        id: 8,
        title: "Estrategias Avanzadas de Aseguramiento de la Calid",
        areas: "Quality Assurance/Staff, Bits/Staff",
        status: "En progreso",
        calification: 'Pendiente',
        fechaInicio: "2023-07-01",
        dateEnd: "2023-09-01",
    },
    {
        id: 9,
        title: "Control de Calidad en Aplicaciones Móviles",
        areas: "Development/Staff, Bits/Staff",
        status: "En progreso",
        calification: 'Pendiente',
        fechaInicio: "2023-07-01",
        dateEnd: "2023-09-01",
    },
    {
        id: 10,
        title: "QA Agile: Metodologías y Mejores Prácticas",
        areas: "Quality Assurance/Staff",
        status: "Terminado",
        calification: '92',
        fechaInicio: "2023-07-01",
        dateEnd: "2023-09-01",
    },
    {
        id: 11,
        title: "C# Curso Completo para ser programador .NET",
        areas: "Proyectos/Bits",
        status: "Terminado",
        calification: '99',
        fechaInicio: "2023-07-01",
        dateEnd: "2023-09-01",
    },
  ];
  